<!--监测设备系统  -->
<template>
  <div class="sys_main_router_box">
    <el-aside>
      <!--菜单-->
      <sideNavigation
        @menu_click="menu_click"
        :navigationList="navigationList"
      ></sideNavigation>
    </el-aside>

    <el-main class="sys_el_main" style="overflow: hidden">
      <router-view
        style="height: 100%;width: 100%;background-color: #fff"
      ></router-view>
    </el-main>
  </div>
</template>

<script>
import sideNavigation from "../../../../../components/sideNavigationNew";

export default {
  name: "index_page_main",
  components: {
    sideNavigation
  },
  data() {
    return {
      navigationList: [
        //没有下级菜单时一定不要有children字段,key作为路由路径,id唯一标识不能重复，下级菜单可以跳转到不同页面,也可以作为参数跳转到同一页面路由配置中设置参数
      ]
    };
  },

  created() {
    this.getMenu();
  },
  methods: {
    getMenu() {
      let menuList = JSON.parse(
        localStorage.getItem(sys_token_prefix + "user_menu") || []
      );
      let navigationList = menuList.filter(menu => {
        return menu.name == "智能决策";
      });
      let resList = null;
      if (navigationList.length > 0) {
        resList = navigationList[0].menuVoList.filter(menu => {
          return menu.name == "物联网一张图";
        });
      }
      this.navigationList = resList[0].menuVoList;
    },
    /*点击菜单*/
    menu_click(key, menu_item) {
      this.$router.push({ path: key });
    }
  }
};
</script>

<style lang="scss"></style>



// WEBPACK FOOTER //
// src/studio/new_cockpit_box/cockpit_children/wlwyzt_cockpit/wlwyzt_asset/index_page_main.vue